import React from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Card } from '../ui/Card';
import { PipelineLines } from '../graphics/PipelineLines';
import { ShieldCheckIcon, MessageSquareIcon, ScrollTextIcon, AwardIcon, ListChecksIcon, TruckIcon, BriefcaseIcon, HandshakeIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
const featureIcons = [ShieldCheckIcon, MessageSquareIcon, ScrollTextIcon, AwardIcon, ListChecksIcon, TruckIcon, BriefcaseIcon, HandshakeIcon];
export function Solution() {
  const {
    lang
  } = useLang();
  const t = dictionary.solution;
  const features = t.features[lang];
  return <section id="solution" className="relative py-24 md:py-32 bg-navy-deep overflow-hidden" data-id="element-479">
      <div className="absolute inset-0 tech-grid opacity-50" aria-hidden="true" data-id="element-480" />
      <PipelineLines className="absolute top-0 left-0 right-0 h-24 text-gold/40" data-id="element-481" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8" data-id="element-482">
        <SectionHeading variant="dark" eyebrow={t.eyebrow[lang]} title={t.title[lang]} data-id="element-483" />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-484">
          {features.map((f, i) => {
          const Icon = featureIcons[i];
          return <Card key={f.title} variant="dark" hover delay={i * 0.04} className="p-6" data-id="element-485">
                <div className="w-10 h-10 flex items-center justify-center bg-gold/10 border border-gold/30 rounded-sm mb-4" data-id="element-486">
                  <Icon className="w-4.5 h-4.5 text-gold" data-id="element-487" />
                </div>
                <h3 className="text-white text-[15px] font-medium mb-2 leading-snug" data-id="element-488">
                  {f.title}
                </h3>
                <p className="text-slate-400 text-[13.5px] leading-relaxed" data-id="element-489">
                  {f.body}
                </p>
              </Card>;
        })}
        </div>
      </div>

      <PipelineLines className="absolute bottom-0 left-0 right-0 h-24 text-gold/40 rotate-180" data-id="element-490" />
    </section>;
}